import React, { useCallback, useEffect, useState } from 'react';

import DateUtils from 'utility/Format/Date/DateUtils';

import SliderValue from './__partials/SliderValue';
import { NumberTuple } from './types';

import styles from './TimeSlider.module.scss';

import RangeSlider from '.';

interface TimeSliderProps {
    label?: string;
    onChange?: (value: NumberTuple) => void;
    min?: number;
    max?: number;
    initialMin?: number;
    initialMax?: number;
    customClassList?: {
        Wrapper?: string;
    };
}

const TimeSlider = ({
    label = '',
    onChange,
    min = 0,
    max = 0,
    initialMin = 0,
    initialMax = 0,
    customClassList,
}: TimeSliderProps) => {
    const [selectedValues, setSelectedValues] = useState<NumberTuple>([
        initialMin,
        initialMax,
    ]);

    const onResetSlider = useCallback(() => {
        setSelectedValues([min, max]);
    }, [max, min]);

    useEffect(() => {
        if (min === initialMin && max === initialMax) {
            onResetSlider();
        }
    }, [initialMax, initialMin, onResetSlider, min, max]);

    useEffect(() => {
        setSelectedValues([initialMin, initialMax]);
    }, [initialMax, initialMin]);

    return (
        <div className={customClassList?.Wrapper}>
            {label && <div className={styles.Label}>{label}</div>}
            <RangeSlider
                value={selectedValues}
                min={min}
                max={max}
                minDistance={30}
                step={30}
                onChange={setSelectedValues}
                onAfterChange={onChange}
            />
            <SliderValue
                format={(value) => {
                    if (value === 1440) {
                        return DateUtils.formatMinutes(1439, false, true);
                    }
                    return DateUtils.formatMinutes(value, false, true);
                }}
                value={selectedValues}
                isReadOnly
            />
        </div>
    );
};

export default TimeSlider;
